<template>
  <PDropdown
    :same-width="false"
    :placement="placement"
    :offset="5"
    :allow-overflow="true"
    @open="isDropdownOpen = true"
    @close="onDropDownClose"
  >
    <template #activator="{ toggle, isOpen }">
      <PButton
        size="icon"
        mode="tertiary-borderless"
        @click="toggle"
        v-bind="attrs"
        :disabled="disabled"
        :aria-expanded="isOpen"
      >
        <OhVueIcon
          :name="menuIcon"
          :scale="size === 'md' ? 1.5 : 1"
          :class="disabled ? 'text-grey-425' : 'text-blue-france-sun-113'"
        />
      </PButton>
    </template>

    <template #default="{ close }">
      <div v-if="isDropdownOpen" class="px-2 py-1 flex flex-col gap-1 text-grey-50 text-sm">
        <slot :close="close"></slot>
      </div>
    </template>
  </PDropdown>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { useIcons, PButton, PDropdown, timeout } from "@pasta/box-v2";
import { type Placement } from "@popperjs/core";
import { OhVueIcon } from "oh-vue-icons";
import { RiMore2Fill } from "oh-vue-icons/icons";
import { ref, useAttrs } from "vue";

const [menuIcon] = useIcons(RiMore2Fill);

interface Props {
  placement?: Placement;
  size?: "sm" | "md";
  disabled?: boolean;
}
withDefaults(defineProps<Props>(), {
  placement: "right",
  size: "md",
});

const attrs: any = useAttrs();
const isDropdownOpen = ref(false);

async function onDropDownClose() {
  // fixes invoke saved flux (nested dropdowns)
  await timeout(100);
  isDropdownOpen.value = false;
}
</script>
